import { RcFile } from 'antd/lib/upload';
import { UploadFile } from 'antd/lib/upload/interface';

import { Nullable } from 'shared/types';

// ****** ENUMS ******

export enum mediaTypeId {
  photo = 1,
  video = 2,
  pedigreeFile = 5,
}

export enum mediaStatusId {
  pendingReview = 1,
  approved = 2,
  published = 3,
  hidden = 4,
  rejected = 9,
}

export enum photoSizeId {
  small = 1,
  medium = 2,
  large = 3,
  thumbnail = 4,
  largeResize = 6,
}

export enum mediaVisibilityId {
  private = 1,
  public = 2,
  hidden = 3,
}

// ****** INTERFACES ******

export interface Media {
  id?: number;
  uid?: string;
  filePath?: string;
  originalFilePath?: string;
  dataUrl?: string;
  name?: string;
  visibilityId?: number;
  type?: string;
  size?: number;
  mediaEntityId?: number;
  mediaEntity?: string;
  mediaStatusId?: number;
  file?: RcFile;
  files?: UploadFile[] | undefined;
  mediaTypeId?: number;
  isDefault?: number;
  viewOrder: number;
  attributes?: MediaAttributes[];
  encoded?: Nullable<string>;
  mediaVariants: MediaVariantsContent[];
  pendingEdit?: Nullable<Media>;
  uploadedAt: string;
  uploadedByUserId?: number;
  mediaVisibilityDeferral?: Nullable<string>;
  hashed_id?: string;
  checked: boolean;
  // Client-only timestamp stamped when a PhotoPea edit overwrites this
  // media in place (same filePath), used to cache-bust its thumbnail URL.
  clientUpdatedAt?: number;
}

export interface MediaVariantsContent {
  id: number;
  dataUrl?: string;
  filePath: string;
  mediaId: number;
  photoSizeId: number;
}

export interface MediaAttributes {
  value: number | string;
  name: string;
  mediaId: number;
}
